export const keyValueMirror = (...keys) => {
  return keys.reduce((obj, key) => ({ ...obj, [key]: key }), {});
};
